import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


import {PatientComponent} from "./list.component";
import {ResultsReviewComponent} from "./results-review.component";
import {LabOrderComponent} from "./lab-order.component";
import {InitialQuestionnaireComponent} from "./initial-questionnaire.component";
import {InitialExamComponent} from "./initial-exam.component";
import {FollowupExamComponent} from "./followup-exam.component";
import {ExposureCalendarComponent} from "./exposure-calendar.component";
import {PatientCreateComponent} from "./create.component";

// Chart.js Angular 2 Directive by Valor Software (npm)
import { ChartsModule } from 'ng2-charts/ng2-charts';

import { FlotModule } from '../../components/charts/flotChart';
import { IboxtoolsModule } from '../../components/common/iboxtools/iboxtools.module';
import { PeityModule } from '../../components/charts/peity';
import { SparklineModule } from '../../components/charts/sparkline';
import { JVectorMapModule } from '../../components/map/jvectorMap';
import { BrowserModule } from '@angular/platform-browser'

@NgModule({
  declarations: [PatientComponent,ResultsReviewComponent,LabOrderComponent,InitialQuestionnaireComponent,InitialExamComponent,FollowupExamComponent,ExposureCalendarComponent,PatientCreateComponent],
  imports     : [BrowserModule,ChartsModule, FlotModule,IboxtoolsModule,PeityModule,SparklineModule,JVectorMapModule],
  exports     : [PatientComponent,ResultsReviewComponent,LabOrderComponent,InitialQuestionnaireComponent,InitialExamComponent,FollowupExamComponent,ExposureCalendarComponent,PatientCreateComponent],
})
export class PatientModule { }



// WEBPACK FOOTER //
// ./src/app/views/patients/patients.module.ts